/** @jsx jsx */
import type { ReactNode } from 'react';
import type { WithDataAttributeProp } from '@balance-web/core';
import { jsx } from '@balance-web/core';
import { Inline } from '@balance-web/inline';
import { useTheme } from '@balance-web/theme';

export type HeaderProps = WithDataAttributeProp<{
  children: ReactNode;
}>;

export const Header = ({ children, data }: HeaderProps) => {
  const { borderWidth, palette } = useTheme();
  return (
    <Inline
      alignY="center"
      css={{
        borderBottom: `${borderWidth.standard} solid ${palette.global.border}`,
      }}
      data={data}
      paddingX="large"
      paddingY="medium"
    >
      {children}
    </Inline>
  );
};
